import { Theme } from '@simplybenefits/sb-ui-library';

const colors = Theme.colors;
const fonts = Theme.fonts;
const globalStyles = Theme.globalStyles;
// const createTheme = Theme.createTheme(false);

export { colors, fonts, globalStyles };